(ns global.endor.checkout.ui.style.elements
  "This namespace aggregates 3 figma files:

  - CONTENT_LAYOUT
  - PAGE_LAYOUT
  - STYLING

  It also defines some useful things like fonts (TODO sync with figma somehow)"
  (:require [global.endor.checkout.ui.style.base :as base]))

;; text

(def font {:h1 {:fontSize 40
                :lineHeight 1.15
                :fontFamily "Space Grotesk"
                :fontWeight 400}
           :h2 {:fontSize 32
                :lineHeight 1.15
                :fontFamily "Space Grotesk"
                :fontWeight 400}
           :h3 {:fontSize 24
                :lineHeight 1.15
                :fontFamily "Space Grotesk"
                :fontWeight 400}
           :h4 {:fontSize 20
                :lineHeight 1.15
                :fontFamily "Space Grotesk"
                :fontWeight 400}
           :body {:fontSize 16
                  :lineHeight 1.35
                  :fontFamily "Inter"
                  :fontWeight 400}
           :tag {:fontSize 12
                 :lineHeight 1.15
                 :fontFamily "Inter"
                 :fontWeight 300}
           :tag-caps {:fontSize 12
                      :lineHeight 1.15
                      :fontFamily "Inter"
                      :fontWeight 300
                      :textTransform "uppercase"}
           :stats {:fontSize 10
                   :lineHeight 1.15
                   :fontFamily "Inter"
                   :fontWeight 300}
           :caption {:fontSize 14
                     :lineHeight 1.45
                     :fontFamily "Space Grotesk"
                     :fontWeight 400}
           :small {:fontSize 14
                   :lineHeight 1.35
                   :fontFamily "Inter"
                   :fontWeight 300}
           :metrics {:fontSize 10
                     :fontFamily "Space Grotesk"
                     :textTransform "uppercase"
                     :fontWeight 400}})

;; page_layout

(def devices
  {:width 390
   :height 844
   :margin (base/spacing :spacing-16)
   :margin-top (base/spacing :spacing-64)
   :margin-bottom-small (base/spacing :spacing-128)
   :margin-bottom-large (base/spacing :spacing-196)
   :gutter (base/spacing :spacing-16)
   :columns 4})

(def stacking
  {:left-right {:extra-large (base/spacing :spacing-48)
                :large (base/spacing :spacing-24)
                :medium (base/spacing :spacing-16)
                :small (base/spacing :spacing-8)
                :extra-small (base/spacing :spacing-4)
                :none (base/spacing :spacing-none)}

   :top-bottom {:extra-large (base/spacing :spacing-48)
                :large (base/spacing :spacing-32)
                :medium (base/spacing :spacing-24)
                :small (base/spacing :spacing-16)
                :extra-small (base/spacing :spacing-12)
                :2x-small (base/spacing :spacing-8)
                :none (base/spacing :spacing-none)}})

;; content_layout

(def content-width
  {:fill-screen (devices :width)
   :fill-grid 342
   :extra-large 342
   :large 342
   :medium 342
   :small 342
   :extra-small 163
   :mini 163})

(def padding
  {:top-bottom {:none (base/spacing :spacing-none)
                :extra-small (base/spacing :spacing-2)
                :small (base/spacing :spacing-4)
                :medium (base/spacing :spacing-8)
                :large (base/spacing :spacing-16)
                :extra-large (base/spacing :spacing-24)
                :2x-large (base/spacing :spacing-32)}

   :left-right {:none (base/spacing :spacing-none)
                :extra-small (base/spacing :spacing-2)
                :small (base/spacing :spacing-4)
                :medium (base/spacing :spacing-8)
                :large (base/spacing :spacing-16)
                :extra-large (base/spacing :spacing-24)
                :2x-large (base/spacing :spacing-32)}})

(def gap
  {:top-bottom {:none (base/spacing :spacing-none)
                :extra-small (base/spacing :spacing-2)
                :small (base/spacing :spacing-4)
                :medium (base/spacing :spacing-8)
                :large (base/spacing :spacing-16)
                :extra-large (base/spacing :spacing-32)
                :2x-large (base/spacing :spacing-48)
                :3x-large (base/spacing :spacing-64)}

   :left-right {:none (base/spacing :spacing-none)
                :extra-small (base/spacing :spacing-2)
                :small (base/spacing :spacing-4)
                :medium (base/spacing :spacing-8)
                :large (base/spacing :spacing-16)
                :extra-large (base/spacing :spacing-32)
                :2x-large (base/spacing :spacing-48)
                :3x-large (base/spacing :spacing-64)}})

;; styling

(def radius
  {:full (base/radius :radius-full)
   :large (base/radius :radius-16)
   :medium (base/radius :radius-8)
   :small (base/radius :radius-4)
   :extra-small (base/radius :radius-2)
   :none (base/radius :radius-none)})

(def bg-blur
  {:full 20
   :large 48})
